// Shared empty state: a single line naming concrete examples of what belongs in
// this list. It never renders an action button — the "add" action always lives in
// the section header, so putting one here too would duplicate it.
import he from '../i18n/he';

export default function EmptyState({ text }) {
  return <div className="empty">{text || he.common.empty}</div>;
}
